import type { TeamMember, TrackingDataListItem } from '@api'

export function getActivityStateById(
  membersOrEntries: TeamMember[] | TrackingDataListItem[],
  id: number,
) {
  const memberOrEntry = membersOrEntries.find((entry) => entry.userId === id)

  return memberOrEntry?.activityState || 'OFFLINE'
}
